import { useState } from "react";
import { api, formatApiError } from "../../lib/api";
import { Logo } from "../site/Logo";
import { Field, inputCls } from "./Field";

export const AdminLogin = ({ onLogin }) => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      const { data } = await api.post("/auth/login", { email, password });
      onLogin(data);
    } catch (err) {
      setError(formatApiError(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="grid min-h-screen place-items-center bg-[#0B0B0E] px-5">
      <form onSubmit={submit} className="w-full max-w-sm rounded-2xl border border-white/10 bg-[#12121A] p-7" data-testid="admin-login-form">
        <Logo size={44} />
        <h1 className="mt-5 font-display text-3xl font-extrabold uppercase text-white">Staff login</h1>
        <p className="mt-1 text-sm text-zinc-400">Edit classes, timings and rates.</p>
        <div className="mt-6 space-y-4">
          <Field label="Email"><input className={inputCls} type="email" required value={email} onChange={(e) => setEmail(e.target.value)} data-testid="admin-email-input" autoComplete="username" /></Field>
          <Field label="Password"><input className={inputCls} type="password" required value={password} onChange={(e) => setPassword(e.target.value)} data-testid="admin-password-input" autoComplete="current-password" /></Field>
        </div>
        {error && <p className="mt-4 rounded-lg border border-[#FF2D7B]/40 bg-[#FF2D7B]/10 px-3 py-2 text-sm text-[#ff8fb5]" data-testid="admin-login-error">{error}</p>}
        <button disabled={busy} className="mt-6 w-full rounded-full bg-[#CCFF00] py-3 font-bold text-black disabled:opacity-60" data-testid="admin-submit-button">
          {busy ? "Signing in…" : "Sign in"}
        </button>
        <a href="/" className="mt-4 block text-center text-sm text-zinc-400 hover:text-white" data-testid="admin-back-to-site">← Back to site</a>
      </form>
    </div>
  );
};
